import PropTypes from 'prop-types';
import styled from 'styled-components';

import { AspectRatio } from './AspectRatio';
import theme from './theme';

type Props = {
  coverBackgroundImage?: string;
};

const AspectRatioCoverImage = styled(AspectRatio)<Props>`
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 0 auto;
  background-image: ${({ coverBackgroundImage }: Props) => coverBackgroundImage};
`;

AspectRatioCoverImage.defaultProps = {
  coverBackgroundImage: undefined,
  theme,
};

AspectRatioCoverImage.propTypes = {
  ...AspectRatio.propTypes,
  coverBackgroundImage: PropTypes.string,
  theme: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

AspectRatioCoverImage.displayName = 'AspectRatioCoverImage';

export { AspectRatioCoverImage };
